import { render } from "./cookiesPrivacy.vue?vue&type=template&id=3d4dcc8b&scoped=true&ts=true"
import script from "./cookiesPrivacy.vue?vue&type=script&lang=ts"
export * from "./cookiesPrivacy.vue?vue&type=script&lang=ts"

import "./cookiesPrivacy.vue?vue&type=style&index=0&id=3d4dcc8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4dcc8b"]])

export default __exports__